/**
 * Digits only, for `inputMode: 'numeric'` fields.
 *
 * Non-digits are dropped rather than the edit being rejected outright: a value that arrives
 * already formatted - a pasted `8255 8269 1519`, an Aadhaar number stored with its spaces -
 * would otherwise be impossible to edit at all, because every keystroke on it, backspace
 * included, still carries the spaces and would be thrown away.
 */
export function filterNumericInput(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Digits and one decimal point with at most two places after it, for `inputMode: 'decimal'`
 * fields. Filtered on the same terms as `filterNumericInput`: stray characters are dropped,
 * a second point and a third decimal place are simply not taken.
 */
export function filterDecimalInput(value: string): string {
  const cleaned = value.replace(/[^\d.]/g, '');
  const point = cleaned.indexOf('.');
  if (point < 0) return cleaned;
  const whole = cleaned.slice(0, point);
  const fraction = cleaned.slice(point + 1).replace(/\./g, '').slice(0, 2);
  return `${whole}.${fraction}`;
}

/** A decimal field's value shown to two places on blur ("3.5" → "3.50"); blank stays blank. */
export function toTwoDecimals(value: unknown): string {
  if (value === '' || value == null) return '';
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed.toFixed(2) : String(value);
}
